/** @format */

import { Component, Input } from '@angular/core';

import { CommonModule } from '@angular/common';

@Component({
    selector: 'plp-components-single-feature-spot',
    templateUrl: './single-feature-spot.component.html',
    styleUrls: ['./single-feature-spot.component.scss'],
    imports: [CommonModule]
})
export class PlpSingleFeatureSpotComponent {
	textColorVariants = {
		dark: 'plp-feature-dark-text',
		light: 'plp-feature-light-text'
	};

	textBoxPositionVariants = {
		left: 'block-left',
		right: 'block-right'
	};

	textBoxBackgroundColorVariants = {
		red: 'plp-feature-red',
		black: 'plp-feature-black',
		white: 'plp-feature-white'
	};

	headlineFont = {
		multiHorizontalFont: 'hmf-display-m-m hmf-display-xs',
		horizontalFont: 'hmf-display-m-l hmf-display-xs'
	};

	subHeadlineFont = {
		multiHorizontalFont: 'hmf-header-m-m hmf-subheader-m',
		horizontalFont: 'hmf-header-m-l hmf-subheader-m'
	};

	@Input() fontFamily;

	@Input()
	textColor = 'light';

	@Input()
	textBoxPosition = 'left';

	@Input()
	textBoxBackgroundColor = 'black';

	@Input()
	upperText = '';

	@Input()
	headline = '';

	@Input()
	subhead = '';

	@Input()
	link = '';

	@Input()
	altText = '';

	@Input()
	mobileImage: string;

	@Input()
	image: string;

	@Input()
	detailsText = '';

	@Input()
	detailsLink = '';

	@Input()
	imageTitle = '';

	@Input()
	dataEm: string;
}
